<div class="app-grid-fluid garage">
  <div class="grid grid-nogutter justify-content-center margin-over-bottom-sidebar">
    <div
      class="col-12 sm:col-10 xl:col-5 home-content-swipe-surface"
      [style]="{maxWidth: '900px'}"
      appHomeTabSwipe
      [homeTabSwipePreviousCount]="previousTabCount"
      [homeTabSwipeNextCount]="nextTabCount"
      (homeTabSwipe)="onHomeTabSwipe($event)"
      (homeTabSwipePreview)="onHomeTabSwipePreview($event)"
      (homeTabSwipeSettled)="onHomeTabSwipeSettled()"
    >
      <nav class="home-content-tabs screen-sticky-control" role="tablist" [attr.aria-label]="'features.home.tabs.label' | translate">
        <button
          *ngFor="let tab of tabs"
          type="button"
          class="home-content-tabs__pill"
          role="tab"
          [attr.id]="'home-tab-' + tab.id"
          [attr.aria-selected]="activeTab === tab.id"
          [attr.aria-controls]="'home-tab-panel-' + tab.id"
          [class.home-content-tabs__pill--active]="activeTab === tab.id"
          (click)="selectTab(tab.id)"
        >{{ tab.label | translate }}</button>
      </nav>

      <div class="home-content-tab-viewport">
        <div
          *ngFor="let panel of homeTabPanels; trackBy: trackByHomeTabPanel"
          class="home-content-tab-panel"
          [class.home-content-tab-panel--active]="panel.role === 'active'"
          [class.home-content-tab-panel--preview]="panel.role !== 'active'"
          [class.home-content-tab-panel--promoting]="panel.role === 'promoting'"
          [style.--home-tab-panel-offset]="panel.offsetPercent + '%'"
          [attr.aria-hidden]="panel.role === 'active' ? null : 'true'"
          [attr.inert]="panel.role === 'active' ? null : ''"
        >
          <ng-container [ngTemplateOutlet]="homeTab" [ngTemplateOutletContext]="{$implicit: panel.id, renderMode: panel.renderMode, previewMediaEnabled: panel.previewMediaEnabled}"></ng-container>
        </div>
      </div>

      <ng-template #homeTab let-tab let-renderMode="renderMode" let-previewMediaEnabled="previewMediaEnabled">
        <section
          *ngIf="tab === 'timeline'"
          id="home-tab-panel-timeline"
          role="tabpanel"
          aria-labelledby="home-tab-timeline"
          data-tutorial="tutorial-home-timeline"
        >
          <app-timeline
            [renderMode]="renderMode || 'active'"
            [previewMediaEnabled]="previewMediaEnabled"
            [previewCurrentUser]="currentUser"
            [writingPostEnabled]="true"
            [viewType]="ViewTypeEnum.LIST"
            [syncViewWithUrl]="false"
            [prefetchEnabled]="true"
            [postTypes]="timelinePostTypes"
            [preloadedPage]="timelinePage"
            [awaitPreloadedPage]="preloadPending.timeline"
            [restoredState]="timelineStates.timeline"
            [noResultsMsg]="'common.no_posts'|translate"
            [alreadyOnRecentMsg]="'common.already_on_recent'"
            (timelineStateChange)="onTimelineStateChange('timeline', $event)"
            (timelineScrollChange)="onTimelineScrollChange('timeline', $event)"
          ></app-timeline>
        </section>

        <section *ngIf="tab === 'feed'" id="home-tab-panel-feed" role="tabpanel" aria-labelledby="home-tab-feed">
          <app-home-feed-list
            [attr.aria-busy]="feedPage ? null : 'true'"
            [preloadedPage]="feedPage || feedLoadingPage"
            [renderMode]="feedPage ? (renderMode || 'active') : 'swipe-preview'"
            [previewMediaEnabled]="!!feedPage && previewMediaEnabled"
          ></app-home-feed-list>
        </section>

        <section
          *ngIf="tab === 'media'"
          id="home-tab-panel-media"
          role="tabpanel"
          aria-labelledby="home-tab-media"
        >
          <app-timeline
            [renderMode]="renderMode || 'active'"
            [previewMediaEnabled]="previewMediaEnabled"
            [previewCurrentUser]="currentUser"
            [writingPostEnabled]="false"
            [viewType]="ViewTypeEnum.GRID"
            [syncViewWithUrl]="false"
            [prefetchEnabled]="true"
            [gridTileClickAction]="'open-gallery'"
            [gridGalleryVideoPrewarmEnabled]="true"
            [postTypes]="mediaPostTypes"
            [preloadedPage]="mediaPage"
            [awaitPreloadedPage]="preloadPending.media"
            [restoredState]="timelineStates.media"
            [gridColumns]="mediaGridColumns"
            [noResultsMsg]="'common.no_media' | translate"
            (timelineStateChange)="onTimelineStateChange('media', $event)"
            (timelineScrollChange)="onTimelineScrollChange('media', $event)"
          ></app-timeline>
        </section>

        <section
          *ngIf="tab === 'reels'"
          id="home-tab-panel-reels"
          role="tabpanel"
          aria-labelledby="home-tab-reels"
        >
          <!--
            This is the visual bridge between the Home swipe track and the
            full-screen gallery. It deliberately owns only an image: mounting
            a grid here would create hidden cards and media components beneath
            the overlay.
          -->
          <div
            class="reels-modal-shell"
            [class.reels-modal-shell--preview]="renderMode === 'swipe-preview'"
            [attr.aria-busy]="renderMode !== 'swipe-preview' || !getReelsShellPoster() ? 'true' : null"
          >
            <img
              *ngIf="getReelsShellPoster() as poster"
              class="reels-modal-shell__poster"
              [src]="poster"
              alt=""
              loading="eager"
              decoding="async"
            >
            <div *ngIf="renderMode !== 'swipe-preview' || !getReelsShellPoster()" class="reels-modal-shell__loading">
              <app-spinner [inline]="true"></app-spinner>
            </div>
          </div>
        </section>
      </ng-template>
    </div>
  </div>
</div>
